import { useEffect } from 'react';
import { YANDEX_KIT_BRAND_NAME, YANDEX_YCP_BRAND_NAME } from '../../const';
import { EMPTY_DASH } from '../../constants';
import { checkIsYCPBrand } from '../../ycp';

export function useSetDocumentTitle(text?: string) {
    useEffect(() => {
        if (document && text) {
            const brandName = checkIsYCPBrand() ? YANDEX_YCP_BRAND_NAME : YANDEX_KIT_BRAND_NAME;

            document.title = `${brandName} ${EMPTY_DASH} ${text}`;
        }
    }, [text]);
}
